<template lang="pug" src="./navigation-mobile.pug"></template>

<script>
export default {
  data () {
    return {
      showMenu: false
    }
  },
  computed: {
    props () {
      return this.$store.state.app.nav
    },
    links () {
      return this.$router.options.routes
    }
  },
  methods: {
    toggleMenu () {
      this.showMenu = !this.showMenu
      this.showMenu ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    },
    goToPage (i) {
      this.$router.push(i)
      this.showMenu = false
      this.showMenu ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    },
    goToHome () {
      this.$router.push('/')
      this.showMenu = false
      this.showMenu ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    }
  }
}
</script>



// WEBPACK FOOTER //
// navigation-mobile.vue?73eb082c